import React, { memo, useCallback } from 'react';
import head from 'lodash/head';
import { ElectricVehicle, YamtIcon } from '@yme/assets/icons';
import { TypeA2 } from '@yme/assets/icons/license-types';
import { Checkbox } from '@yme/atoms/checkbox';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { CardProductPriceBlock } from '@yme/common/components/molecules/cards/card-product';
import { ElectricType } from '@yme/components/Header/MenuUnitCard/constants';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useWishlist } from '@yme/hooks/useWishlist';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DRIVER_LICENSE_A2 } from '@yme/utils/constants';
import { FavoriteCardButton } from '../favorite-card-button';
import { buildImageProps, getDriverLicenseIcon } from './helpers';
import { FilterCompareCardStyled, ImageStyled, FlexWrapperStyled, LinkStyled, TitleStyled, ContainerIconsStyled, YAMTIconStyled, ProductLabelStyled, } from './styled';
function FilterCompareCardComponent(props) {
    const { isComparisonFilterResult, image, title, price, discountedValue, isNewLabelShowed, driverLicense, idCard = '', isYAMTIconShowed, is35KWIconShowed, extraInformationTooltipText, url, isLabelFromVisible = false, isRightToLeft = false, isCheckBoxNeeded = true, isChecked, isDisabled, sku, onClick, handleAddComparisonProduct, handleRemoveComparisonProduct, electricVehicleIcon, } = props;
    const { t } = useTranslation();
    const imageProps = buildImageProps(image);
    const { isLiked } = useWishlist();
    const { isMobileView } = useWindowSize();
    const onCheckboxChange = useCallback((event) => {
        if (event.target.checked) {
            handleAddComparisonProduct();
        }
        else {
            handleRemoveComparisonProduct();
        }
    }, [handleAddComparisonProduct, handleRemoveComparisonProduct]);
    const onCheckboxClick = useCallback((event) => {
        event.stopPropagation();
        if (isDisabled) {
            event.preventDefault();
        }
    }, [isDisabled]);
    return (React.createElement(LinkStyled, { to: url, onClick: onClick },
        React.createElement(FilterCompareCardStyled, { mb: "32px", flexDirection: "column" },
            React.createElement(FlexWrapper, { bg: colorCoreWhite1000, flexDirection: "column" },
                React.createElement(FlexWrapperStyled, { justifyContent: "center" },
                    React.createElement(ImageStyled, { ...imageProps }),
                    isComparisonFilterResult && (React.createElement(ProductLabelStyled, { className: "filter-compare-card", isMobileView: isMobileView, isRightToLeft: isRightToLeft, isNew: isNewLabelShowed }))),
                React.createElement(FlexWrapper, { padding: "10px 16px", minHeight: "56px", justifyContent: isCheckBoxNeeded ? 'space-between' : 'flex-end' },
                    isCheckBoxNeeded && (React.createElement(Checkbox, { value: t('productsGrid_compare_button'), isRightToLeft: isRightToLeft, id: idCard, onChange: onCheckboxChange, onClick: onCheckboxClick, checked: isChecked, disabled: isDisabled })),
                    React.createElement(ContainerIconsStyled, null,
                        React.createElement(FlexWrapper, { gap: "4px", alignItems: "center" },
                            driverLicense?.[0] && (React.createElement(SVGIcon, { type: getDriverLicenseIcon(driverLicense[0]), size: ICON_SIZE.sm })),
                            is35KWIconShowed && head(driverLicense) !== DRIVER_LICENSE_A2 && (React.createElement(SVGIcon, { type: TypeA2, size: ICON_SIZE.sm }))),
                        isYAMTIconShowed && React.createElement(YAMTIconStyled, { type: YamtIcon }),
                        electricVehicleIcon === ElectricType.ELECTRIC_SCOOTER && (React.createElement(SVGIcon, { type: ElectricVehicle, size: ICON_SIZE.sm }))))),
            React.createElement(FavoriteCardButton, { onLike: undefined, isLiked: isLiked(sku) }),
            React.createElement(FlexWrapper, { mtMobile: "8px", mtTablet: "16px" },
                React.createElement(TitleStyled, { weight: 500 }, title)),
            price && (React.createElement(CardProductPriceBlock, { price: price, isRightToLeft: isRightToLeft, discount: discountedValue, extraInformationTooltipText: extraInformationTooltipText, isLabelFromVisible: isLabelFromVisible })))));
}
export const FilterCompareCard = memo(FilterCompareCardComponent);
FilterCompareCard.displayName = 'FilterCompareCard_Molecule';
